import { Injectable, OnDestroy } from '@angular/core';
import { UserService } from '@services/user.service';
import { Apollo, gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { distinctUntilChanged, map, Observable, retry, switchMap, timer } from 'rxjs';
import { GraphQLData } from './common/graphql.data';

const FAKE_QUERY = gql`
	query {
		__typename
	}
`;

@Injectable()
export class GraphQLSubscribe extends GraphQLData implements OnDestroy {
	constructor(
		apollo: Apollo,
		private userService: UserService,
	) {
		super(apollo);
	}

	subscribe$(doc?: DocumentNode): Observable<any> {
		return this.userService.account$.pipe(
			map((account) => account?.id ?? null),
			distinctUntilChanged(),
			switchMap(() =>
				new Observable<any>((observer) => {
					const ref = this.apollo.watchQuery({ query: FAKE_QUERY });
					const unsubscribe = ref.subscribeToMore({
						document: doc ?? this.command,
						updateQuery: (prev, { subscriptionData }) => {
							if (subscriptionData?.data) {
								observer.next(subscriptionData.data);
							}
							return prev;
						},
						onError: (error) => observer.error(error),
					});
					return () => unsubscribe();
				}).pipe(
					// Reconnect with capped backoff on error instead of dying - otherwise the account
					// listener above won't resubscribe until the next account change.
					retry({
						resetOnSuccess: true,
						delay: (error, attempt) => {
							console.error('GraphQL subscription error, reconnecting:', error);
							return timer(Math.min(50 * 2 ** (attempt - 1), 5000));
						},
					}),
				),
			),
		);
	}
}
